import styled from 'styled-components';

export const Container = styled.section`
  background: #060405;
  display: flex;
  font-family: 'Roboto', sans-serif;
  font-size: 42px;
`;
Container.displayName = 'Container';

export const ColorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 10px;
`;
ColorsContainer.displayName = 'ColorsContainer';

export const ColorsItem = styled.div`
  flex-grow: 1;
`;
ColorsItem.displayName = 'ColorsItem';

export const Logo = styled.img``;
Logo.displayName = 'Logo';

export const LogoContainer = styled.div`
  align-content: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 24px;
  padding: 4px;
`;
LogoContainer.displayName = 'LogoContainer';

export const Points = styled.div`
  color: #fff;
  font-weight: 900;
  min-width: 96px;
  text-align: center;
`;
Points.displayName = 'Points';

export const QuarterTime = styled.div`
  align-items: center;
  color: #fff;
  display: flex;
  font-size: 48px;
  justify-content: center;
  letter-spacing: -4px;
  min-width: 60px;
`;
QuarterTime.displayName = 'QuarterTime';

export const TeamImage = styled.img`
  height: 64px;
  min-width: 80px;
`;
TeamImage.displayName = 'TeamImage';

export const TeamName = styled.div`
  color: #fff;
  font-size: 35px;
  min-width: 280px;
  padding: 0 8px;
  text-align: center;
`;
TeamName.displayName = 'TeamName';

export const TeamsContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
TeamsContainer.displayName = 'TeamsContainer';

export const TeamContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  height: 64px;
`;
TeamContainer.displayName = 'TeamContainer';

export const Timer = styled.div`
  align-items: center;
  color: #fff;
  display: flex;
  font-size: 48px;
  justify-content: center;
  min-width: 150px;
`;
Timer.displayName = 'Timer';

export const TimerContainer = styled.div`
  display: flex;
`;
TimerContainer.displayName = 'TimerContainer';
